import { faIdCard, faUser } from "@fortawesome/free-solid-svg-icons";
import createField from "../../../utils/factory/createField";

export const reportProtocolTransactionFields = [
  {
    section: "Dados do Produto",
    fields: [
      createField({
        id: "report.user_id",
        label: "Responsável pela entrega",
        type: "select",
        placeholder: "Selecione o responsável pela entrega",
        icon: faUser,
      }),
      createField({
        id: "report.cpf_cnpj",
        label: "CPF",
        type: "text",
        placeholder: "Informe o CPF",
        mask: "999.999.999-99",
        icon: faIdCard,
      }),
    ],
  },
];
